module.exports = __webpack_public_path__ + "img/5.1.ed9b92dc.png";